import { roundPrice } from "@/utils/app-helper";

/** Coerce unknown inputs to a safe non‑negative money amount for display. */
export function sanitizeNonNegativeMoney(value: unknown): number {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return 0;
  return roundPrice(n, 2);
}
